import React, { ButtonHTMLAttributes } from 'react'

import { Container } from './styles'

interface PropsBtn<T> extends ButtonHTMLAttributes<T> {
  color?: 'green' | 'white' | 'transparent'
  isVisible?: boolean
}

type Props = PropsBtn<HTMLButtonElement>

const Button: React.FC<Props> = ({
  children,
  isVisible = true,
  color = 'white',
  ...rest
}) => {
  return isVisible ? (
    <Container type="button" color={color} {...rest}>
      {children}
    </Container>
  ) : null
}

export default Button
